/* src/app/modules/login/agent-signup/agent-signup.component.scss */
:host {
  display: block;
}
.signup-content {
  --background:
    linear-gradient(
      
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 65%,
      var(--ion-color-secondary-contrast) 100% );
}
.signup-page-wrap {
  min-height: 100%;
  display: flex;
  justify-content: center;
  padding: 14px 12px 34px;
}
.signup-card {
  position: relative;
  width: min(100%, 520px);
  border-radius: 24px;
  border: 1px solid var(--ion-color-light-tint);
  background:
    linear-gradient(
      165deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
  box-shadow: 0 12px 22px var(--ion-color-secondary-contrast);
  padding: 24px 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.card-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-light-tint);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.2s ease;
  z-index: 10;
}
.card-close-btn ion-icon {
  color: var(--ion-color-primary-contrast);
  font-size: 18px;
  pointer-events: none;
}
.card-close-btn:hover {
  transform: scale(1.06);
  border-color: var(--ion-color-primary);
}
.signup-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  margin-top: 4px;
}
.brand-icon-box {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-secondary-shade);
  box-shadow: 0 8px 16px var(--ion-color-light-tint);
}
.brand-icon-box ion-icon {
  color: var(--ion-color-secondary);
  font-size: 30px;
}
.brand-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: var(--ion-color-secondary-shade);
}
.brand-title {
  margin: 0;
  color: var(--ion-color-secondary-shade);
  font-size: 23px;
  line-height: 1.25;
  font-weight: 700;
}
.brand-sub {
  color: var(--ion-color-primary-contrast);
  font-size: 13px;
  line-height: 1.5;
  max-width: 360px;
}
.signup-progress {
  --mdc-linear-progress-active-indicator-color: var(--ion-color-primary);
  --mdc-linear-progress-track-color: var(--ion-color-light-tint);
  border-radius: 999px;
}
.step-indicator {
  display: flex;
  align-items: center;
  gap: 0;
  margin-top: -4px;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.step-item .step-dot {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid var(--ion-color-light-tint);
  background: var(--ion-color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-item .step-dot ion-icon {
  color: var(--ion-color-primary-contrast);
  font-size: 15px;
}
.step-item .step-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--ion-color-primary-contrast);
}
.step-item.active .step-dot {
  background: var(--ion-color-secondary-shade);
  border-color: white;
}
.step-item.active .step-dot ion-icon {
  color: var(--ion-color-secondary);
}
.step-item.active .step-label {
  color: var(--ion-color-secondary-shade);
}
.step-line {
  flex: 1;
  min-width: 28px;
  height: 2px;
  margin: 0 8px 18px;
  background: var(--ion-color-light-tint);
}
.signup-form {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.field-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.field-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 2px;
}
.field-icon {
  font-size: 16px;
  color: var(--ion-color-secondary-shade);
}
.field-label {
  font-size: 13px;
  color: var(--ion-color-secondary-shade);
  font-weight: 600;
}
.required-star {
  color: var(--ion-color-danger);
  margin-left: 2px;
}
.field-control {
  width: 100%;
}
.field-control mat-icon[matPrefix] {
  color: var(--ion-color-primary-contrast);
  margin-right: 4px;
  font-size: 18px;
}
.info-note {
  --background: color-mix(in srgb, var(--ion-color-secondary-shade) 9%, #ffffff);
  --border-radius: 12px;
  --padding-start: 10px;
  --inner-padding-end: 10px;
  border: 1px solid color-mix(in srgb, var(--ion-color-secondary-shade) 30%, #ffffff);
  margin: 4px 0 6px;
}
.info-note ion-icon {
  color: var(--ion-color-secondary-shade);
  font-size: 17px;
  margin-right: 8px;
}
.info-note ion-label {
  color: var(--ion-color-secondary-shade);
  font-size: 12px;
  line-height: 1.45;
}
.btn-primary-action {
  --background: var(--ion-color-secondary-shade);
  --border-radius: 12px;
  --padding-top: 14px;
  --padding-bottom: 14px;
  --color: var(--ion-color-secondary);
  text-transform: none;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.01em;
}
.btn-secondary-action {
  --border-radius: 12px;
  --padding-top: 12px;
  --padding-bottom: 12px;
  --color: var(--ion-color-secondary-shade);
  --border-color: var(--ion-color-light-tint);
  text-transform: none;
  font-size: 14px;
  font-weight: 600;
}
.otp-card .signup-brand {
  margin-top: 8px;
}
.otp-input-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}
.otp-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--ion-color-danger);
  font-size: 12px;
  font-weight: 600;
}
.otp-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.login-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-top: 1px solid var(--ion-color-light-tint);
  padding-top: 12px;
}
.footer-text {
  color: var(--ion-color-primary-contrast);
  font-size: 13px;
}
.footer-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  color: var(--ion-color-primary);
  font-size: 13px;
  font-weight: 700;
}
.footer-link ion-icon {
  font-size: 15px;
}
mat-form-field {
  width: 100%;
}
mat-form-field .mat-mdc-form-field-subscript-wrapper {
  margin-top: 2px;
}
@media (min-width: 768px) {
  .signup-page-wrap {
    padding-top: 18px;
  }
  .signup-card {
    padding: 28px 24px 24px;
  }
}
/*# sourceMappingURL=agent-signup.component.css.map */
